import { useMemo } from "react";

export interface Project4TWSourceSettingsText {
  unauthorisedWarningText: string;
  environmentLabelText: string;
  projectFilterLabelText: string;
  projectFilterPlaceholderText: string;
  projectFilterHintText: string;
  bucketsToLoadLabelText: string;
  bucketsToLoadPlaceholderText: string;
  bucketsToLoadHintText: string;
  doneBucketLabelText: string;
  doneBucketPlaceholderText: string;
  doneBucketHintText: string;
  assignedToMeLabelText: string;
  assignedToMeHintText: string;
  loadingProjectsText: string;
  loadingBucketsText: string;
  loadErrorText: string;
}

export const useProject4TWSourceSettingsText = (
  t: (key: string) => string,
): Project4TWSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.project4tw.${key}`);

    return {
      unauthorisedWarningText: tKey("unauthorisedWarning"),
      environmentLabelText: tKey("environmentLabel"),
      projectFilterLabelText: tKey("projectFilterLabel"),
      projectFilterPlaceholderText: tKey("projectFilterPlaceholder"),
      projectFilterHintText: tKey("projectFilterHint"),
      bucketsToLoadLabelText: tKey("bucketsToLoadLabel"),
      bucketsToLoadPlaceholderText: tKey("bucketsToLoadPlaceholder"),
      bucketsToLoadHintText: tKey("bucketsToLoadHint"),
      doneBucketLabelText: tKey("doneBucketLabel"),
      doneBucketPlaceholderText: tKey("doneBucketPlaceholder"),
      doneBucketHintText: tKey("doneBucketHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      assignedToMeHintText: tKey("assignedToMeHint"),
      loadingProjectsText: tKey("loadingProjects"),
      loadingBucketsText: tKey("loadingBuckets"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
